import { createAction } from "redux-actions";
import * as actionTypes from "./actionTypes";

export const setupApplication = createAction(actionTypes.SETUP_APPLICATION);
export const destroyApplication = createAction(actionTypes.DESTROY_APPLICATION);
export const updateActiveStep = createAction(actionTypes.UPDATE_ACTIVE_STEP);
export const updateOpenedCards = createAction(actionTypes.UPDATE_OPENED_CARDS);
export const triggerFieldActions = createAction(
  actionTypes.TRIGGER_FIELD_ACTIONS
);
export const verifySavedCards = createAction(actionTypes.VERIFY_SAVED_CARDS);
export const updateSavedCards = createAction(actionTypes.UPDATE_SAVED_CARDS);
export const updateSubmittedApplication = createAction(
  actionTypes.UPDATE_SUBMITTED_APPLICATION
);

export const registerField = createAction(actionTypes.REGISTER_FIELD);
export const unregisterField = createAction(actionTypes.UNREGISTER_FIELD);
export const updateField = createAction(actionTypes.UPDATE_FIELD);

export default {
  setupApplication,
  destroyApplication,
  updateActiveStep,
  updateOpenedCards,
  triggerFieldActions,
  verifySavedCards,
  updateSavedCards,
  updateSubmittedApplication,
  registerField,
  unregisterField,
  updateField
};
